import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useBlogContext } from '../Context/BlogContext';

// import { useAuthContext } from '../AuthContext';

const Signup = () => {
  const {
    Register,
    handleChange2,
    register,
    //   confirmFields,
    //   type,
    //   msg,
    //   buttonLoader,
  } = useBlogContext();

  const [confirmFields, setConfirmFields] = useState(false);

  useEffect(() => {
    setConfirmFields(false);
  }, []);

  return (
    <div className='w-10/12 lg:w-6/12 mx-auto   flex flex-col  justify-center  min-h-screen gap-2'>
      <form
        className='py-6 px-8 flex w-full md:w-6/12 lg:w-10/12 mx-auto flex-col gap-2  items-center bg-gray-200 '
        onSubmit={Register}
      >
        <p className='text-2xl'>Register</p>
        {/* {type ? (
          <p className='text-white bg-red-400 p-2 rounded'>{msg}</p>
        ) : null} */}
        <input
          type='text'
          placeholder='firstname'
          value={register.firstName}
          name='firstName'
          onChange={handleChange2}
          className='my-2 block w-full p-3 rounded-md outline-none bg-gray-100'
        />
        <input
          type='text'
          placeholder='lastname'
          value={register.lastName}
          name='lastName'
          onChange={handleChange2}
          className='my-2 block w-full p-3 rounded-md outline-none bg-gray-100'
        />
        <input
          type='text'
          placeholder='email'
          value={register.email}
          name='email'
          onChange={handleChange2}
          className='my-2 block w-full p-3 rounded-md outline-none bg-gray-100'
        />
        <input
          type='password'
          placeholder='password'
          value={register.password}
          name='password'
          onChange={handleChange2}
          className='my-2 block w-full p-3 rounded-md outline-none bg-gray-100'
        />
        <button
          className={` ${
            confirmFields ? 'bg-gray-400' : ' bg-gray-700 hover:bg-gray-500'
          }  text-white text-sm w-4/12 md:text-base rounded-lg  py-2 px-7 text-white transition ease-linear duration-1000`}
          //   disabled={confirmFields}
        >
          Register {/* {buttonLoader ? 'Loading...' : 'Register'} */}
        </button>
        <p>
          {' '}
          Already Have An Account{' '}
          <Link className='text-blue-700' to='/login'>
            Login
          </Link>{' '}
        </p>{' '}
      </form>
    </div>
  );
};

export default Signup;
